export default "__VITE_ASSET__0b7fc853__"